<template>
  <div class="route-menu-index">
    <!-- Thẻ chính bao ngoài theo phong cách bo tròn chuẩn hệ thống -->
    <v-card class="rounded-xl elevation-3" flat>
      <!-- Tiêu đề và nhóm nút hành động chính -->
      <v-card-title class="text-h6 font-weight-bold pt-4 pb-2 px-6">
        Danh mục menu
        
        <!-- Điều hướng cấp thư mục Menu (Roots) -->
        <div class="d-flex align-center ml-4 flex-wrap">
          <v-chip small color="teal lighten-5" text-color="teal darken-4" class="font-weight-bold mr-1" @click="resetRoots" style="cursor: pointer;">
            <v-icon small left color="teal darken-4">mdi-home</v-icon> Gốc
          </v-chip>
          <template v-for="(item, index) in roots">
            <v-icon small color="grey" class="mx-1" :key="'arrow-' + index">mdi-chevron-right</v-icon>
            <v-chip small color="teal darken-4" dark class="font-weight-bold" :key="'chip-' + index" @click="sliceRoots(index)" style="cursor: pointer;">
              {{ item }}
            </v-chip>
          </template>
        </div>

        <v-spacer></v-spacer>

        <!-- Nút tải lại dữ liệu -->
        <div class="d-flex align-center wrapper mx-1 my-1">
          <v-btn @click="fetchData" outlined color="green lighten-3" class="rounded-lg" block
            style="width: 40px !important; height: 40px; padding: 0px;" title="Tải lại">
            <v-icon color="green darken-4">mdi-refresh</v-icon>
          </v-btn>
        </div>

        <!-- Nút xuất dữ liệu ra file Excel -->
        <vue-excel-xlsx
          :data="excelData"
          :columns="excelColumns"
          :file-name="'DANH_MUC_MENU'"
          :file-type="'xlsx'"
          :sheet-name="'Route_Menu'"
        >
          <v-btn outlined color="teal lighten-3" class="rounded-lg ml-2"
            style="width: 40px !important; height: 40px; padding: 0px;" title="Xuất Excel">
            <v-icon color="teal darken-4">mdi-microsoft-excel</v-icon>
          </v-btn>
        </vue-excel-xlsx>

        <v-divider vertical class="mx-4"></v-divider>

        <!-- Nút tạo menu mới -->
        <v-btn @click="openCreateDialog" dark color="teal darken-4"
          class="rounded-pill elevation-3 ml-4 font-weight-bold px-6">
          <v-icon left>mdi-plus</v-icon> TẠO MENU
        </v-btn>
      </v-card-title>

      <!-- Thanh bộ lọc tiêu chuẩn chuẩn hệ thống -->
      <v-sheet class="grey lighten-4 py-6">
        <div class="d-flex flex-wrap align-center px-6" style="gap: 12px;">
          <!-- Lọc theo ID -->
          <div style="width: 130px;">
            <v-text-field label="ID" placeholder="ID..." dense v-model="filters.id"
              outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
          </div>

          <!-- Lọc theo Tiêu đề -->
          <div style="width: 240px;">
            <v-text-field label="Tiêu đề" placeholder="Tìm theo tiêu đề..." dense v-model="filters.title"
              outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
          </div>

          <!-- Lọc theo Phân loại -->
          <div style="width: 180px;">
            <v-select label="Phân loại" clearable :items="['SECTION', 'SUBHEADER', 'MENU', 'GROUP']"
              dense v-model="filters.type" outlined hide-details color="teal darken-4"
              class="white rounded-lg" placeholder="Tất cả"></v-select>
          </div>

          <!-- Lọc theo Route Name -->
          <div style="width: 200px;">
            <v-text-field label="Route Name" placeholder="Tìm theo route..." dense v-model="filters.routeName"
              outlined hide-details color="teal darken-4" class="white rounded-lg"></v-text-field>
          </div>

          <!-- Nút xóa bộ lọc -->
          <div>
            <v-btn @click="resetFilters" text color="grey darken-2" class="rounded-lg font-weight-bold" height="40">
              <v-icon left small>mdi-filter-remove-outline</v-icon> Xóa lọc
            </v-btn>
          </div>
        </div>
      </v-sheet>

      <!-- Thanh thống kê chip màu chuẩn hệ thống -->
      <v-sheet class="px-6 py-3 d-flex align-center grey lighten-5 flex-wrap"
        style="border-top: 1px solid #e0e0e0; border-bottom: 1px solid #e0e0e0;">
        <div class="subtitle-2 font-weight-bold mr-4 text-uppercase grey--text text--darken-2">Thống kê:</div>
        <v-chip color="blue lighten-4" text-color="blue darken-4" class="mr-3 my-1 font-weight-medium" small>
          <v-icon left small>mdi-file-document-outline</v-icon>
          Tổng menu: <b class="ml-1">{{ items.length }}</b>
        </v-chip>
        <v-chip color="red lighten-4" text-color="red darken-4" class="mr-3 my-1 font-weight-medium" small>
          <v-icon left small>mdi-view-headline</v-icon>
          Section: <b class="ml-1">{{ countType('SECTION') }}</b>
        </v-chip>
        <v-chip color="green lighten-4" text-color="green darken-4" class="mr-3 my-1 font-weight-medium" small>
          <v-icon left small>mdi-menu</v-icon>
          Menu: <b class="ml-1">{{ countType('MENU') }}</b>
        </v-chip>
        <v-chip color="orange lighten-4" text-color="orange darken-4" class="mr-3 my-1 font-weight-medium" small>
          <v-icon left small>mdi-folder-outline</v-icon>
          Group: <b class="ml-1">{{ countType('GROUP') }}</b>
        </v-chip>
        <v-chip color="grey lighten-3" text-color="grey darken-4" class="my-1 font-weight-medium" small>
          <v-icon left small>mdi-format-header-pound</v-icon>
          Subheader: <b class="ml-1">{{ countType('SUBHEADER') }}</b>
        </v-chip>
      </v-sheet>

      <!-- Bảng danh sách Route Menu -->
      <v-data-table
        class="my-custom-table"
        height="calc(100vh - 350px)"
        fixed-header
        :mobile-breakpoint="0"
        :headers="headers"
        :items="filteredItems"
        :loading="isLoading"
        loading-text="Đang tải dữ liệu..."
        :items-per-page="-1"
        :footer-props="{
          itemsPerPageOptions: [20, 50, 100, -1],
          itemsPerPageText: 'Số dòng mỗi trang'
        }"
      >
        <!-- Cột thao tác -->
        <template v-slot:[`item.actions`]="{ item }">
          <div class="d-flex align-center">
            <v-btn x-small depressed rounded class="mx-1 my-1 teal--text text--darken-4 font-weight-bold"
              color="teal lighten-5" @click="openEditDialog(item)">
              <v-icon left small>mdi-pencil</v-icon> Sửa
            </v-btn>
            <v-btn x-small depressed rounded class="mx-1 my-1 red--text text--darken-2 font-weight-bold"
              color="grey lighten-4" @click="confirmDelete(item)">
              <v-icon left small>mdi-delete</v-icon> Xóa
            </v-btn>
          </div>
        </template>

        <!-- Cột Icon -->
        <template v-slot:[`item.icon`]="{ item }">
          <v-avatar size="32" color="teal lighten-5" class="rounded-lg" v-if="item.icon">
            <v-icon small color="teal darken-4">{{ item.icon }}</v-icon>
          </v-avatar>
          <span v-else class="grey--text caption">--</span>
        </template>

        <!-- Cột Tiêu đề -->
        <template v-slot:[`item.transTitle`]="{ item }">
          <div>
            <div class="font-weight-bold">{{ item.title }}</div>
            <div class="caption grey--text text--darken-1" v-if="$t(item.title) !== item.title">{{ $t(item.title) }}</div>
          </div>
        </template>

        <!-- Cột Phân loại -->
        <template v-slot:[`item.type`]="{ item }">
          <v-chip label small :color="getTypeColor(item.type)" dark class="font-weight-bold">
            {{ item.type }}
          </v-chip>
        </template>

        <!-- Cột Nhóm cha (Parent) -->
        <template v-slot:[`item.parentId`]="{ item }">
          <div class="d-flex align-center">
            <span class="mr-2 font-weight-medium grey--text text--darken-2">{{ item.parentId || '--' }}</span>
            <v-btn x-small depressed rounded color="teal lighten-5" class="teal--text text--darken-4 font-weight-bold"
              v-if="item.type === 'SECTION' || item.type === 'GROUP'" @click="pushRoot(item.id)">
              <v-icon left x-small>mdi-folder-open</v-icon> Mở
            </v-btn>
          </div>
        </template>

        <!-- Cột Thứ tự -->
        <template v-slot:[`item.order`]="{ item }">
          <div class="d-flex align-center">
            <b class="mr-2">{{ item.order }}</b>
            <v-btn icon x-small color="blue darken-2" @click="changeItemOrder(item.id, 'increase')" title="Tăng thứ tự">
              <v-icon small>mdi-arrow-up-bold</v-icon>
            </v-btn>
            <v-btn icon x-small color="red darken-2" @click="changeItemOrder(item.id, 'decrease')" title="Giảm thứ tự">
              <v-icon small>mdi-arrow-down-bold</v-icon>
            </v-btn>
          </div>
        </template>

        <!-- Cột Route Name -->
        <template v-slot:[`item.routeName`]="{ item }">
          <v-chip v-if="item.routeName" small outlined color="teal darken-4" class="font-weight-medium caption">
            {{ item.routeName }}
          </v-chip>
          <span v-else class="grey--text caption">--</span>
        </template>

        <!-- Cột Claims -->
        <template v-slot:[`item.claims`]="{ item }">
          <span v-if="item.claims" class="caption font-weight-medium text-truncate d-inline-block" style="max-width: 200px;" :title="item.claims">
            {{ item.claims }}
          </span>
          <span v-else class="grey--text caption">--</span>
        </template>
      </v-data-table>
    </v-card>

    <!-- Hộp thoại tạo mới / cập nhật Menu -->
    <v-dialog v-model="formDialog" max-width="700px" persistent scrollable>
      <v-card class="rounded-xl">
        <v-card-title class="text-h6 font-weight-bold px-6 py-4 d-flex align-center teal darken-4 white--text">
          <v-icon left color="white">mdi-menu</v-icon>
          {{ isEdit ? 'Cập nhật menu #' + (selectedItem ? selectedItem.id : '') : 'Tạo mới menu' }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="formDialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-6 py-4 pt-4 white">
          <detail :item="selectedItem" :mode="isEdit ? 'view' : 'create'" @input="handleDetailInput"></detail>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="px-6 py-3 grey lighten-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text class="rounded-lg font-weight-bold px-4" @click="formDialog = false">Hủy</v-btn>
          <v-btn color="teal darken-4" dark class="rounded-lg font-weight-bold px-6 elevation-2" :loading="isSubmitting" @click="saveForm">
            <v-icon left small>mdi-content-save</v-icon> {{ isEdit ? 'Cập nhật' : 'Tạo mới' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Hộp thoại xác nhận xóa menu -->
    <v-dialog v-model="dialogDelete" max-width="450px" persistent>
      <v-card class="rounded-xl">
        <v-card-title class="text-subtitle-1 font-weight-bold px-6 py-4 d-flex align-center">
          <v-icon left color="error">mdi-alert-circle-outline</v-icon>
          Xác nhận xóa menu
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogDelete = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-6 py-4 pt-4">
          Bạn có chắc chắn muốn xóa mục menu 
          <strong v-if="targetItem" class="red--text text--darken-2">"{{ targetItem.title }} (#{{ targetItem.id }})"</strong>? 
          Thao tác này không thể hoàn tác.
        </v-card-text>
        <v-card-actions class="px-6 pb-4">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text class="rounded-lg font-weight-bold px-4" @click="dialogDelete = false">Hủy</v-btn>
          <v-btn color="red darken-1" dark class="rounded-lg font-weight-bold px-4" depressed @click="cfmDeleteItem">Xóa</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// Nhập các thành phần và API phụ trợ
import Detail from './Detail.vue';
import { conditionGets, Post, Put, conditionDelete, changeOrder } from './api';

export default {
  name: "RouteMenu",
  components: {
    Detail
  },
  data() {
    return {
      // Trạng thái tải và dialog
      isLoading: false,
      isSubmitting: false,
      formDialog: false,
      dialogDelete: false,
      isEdit: false,
      selectedItem: null,
      targetItem: null,
      formData: {},

      // Cây thư mục nhóm menu đang duyệt
      roots: [],

      // Dữ liệu danh sách menu
      items: [],

      // Bộ lọc dữ liệu
      filters: {
        id: '',
        title: '',
        type: null,
        routeName: ''
      },

      // Cấu hình cột hiển thị cho bảng dữ liệu
      headers: [
        { text: 'Thao tác', value: 'actions', width: 140, align: 'center', sortable: false },
        { text: 'ID', align: 'start', value: 'id', width: 80 },
        { text: 'Icon', align: 'center', value: 'icon', width: 80, sortable: false },
        { text: 'Tiêu đề', align: 'start', value: 'transTitle', width: 220 },
        { text: 'Phân loại', align: 'center', value: 'type', width: 120 },
        { text: 'Nhóm cha', align: 'start', value: 'parentId', width: 160 },
        { text: 'Thứ tự', align: 'center', value: 'order', width: 130 },
        { text: 'Route Name', align: 'start', value: 'routeName', width: 160 },
        { text: 'Claims', align: 'start', value: 'claims', width: 200 }
      ]
    };
  },
  computed: {
    // Lọc danh sách menu theo các tiêu chí tìm kiếm
    filteredItems() {
      return (this.items || []).filter(item => {
        if (this.filters.id && !String(item.id).includes(this.filters.id.trim())) {
          return false;
        }
        if (this.filters.title) {
          const title = (item.title || '').toLowerCase();
          const searchTitle = this.filters.title.trim().toLowerCase();
          if (!title.includes(searchTitle)) return false;
        }
        if (this.filters.type && item.type !== this.filters.type) {
          return false;
        }
        if (this.filters.routeName) {
          const route = (item.routeName || '').toLowerCase();
          const searchRoute = this.filters.routeName.trim().toLowerCase();
          if (!route.includes(searchRoute)) return false;
        }
        return true;
      });
    },

    // Dữ liệu phục vụ xuất file Excel
    excelData() {
      return (this.filteredItems || []).map(x => ({
        id: x.id,
        title: x.title,
        icon: x.icon || '',
        type: x.type || '',
        parentId: x.parentId || '',
        order: x.order || 0,
        routeName: x.routeName || '',
        claims: x.claims || ''
      }));
    },

    // Cấu hình cột cho file Excel
    excelColumns() {
      return [
        { label: 'ID', field: 'id' },
        { label: 'Tiêu đề', field: 'title' },
        { label: 'Icon', field: 'icon' },
        { label: 'Phân loại', field: 'type' },
        { label: 'Nhóm cha', field: 'parentId' },
        { label: 'Thứ tự', field: 'order' },
        { label: 'Route Name', field: 'routeName' },
        { label: 'Claims', field: 'claims' }
      ];
    }
  },
  methods: {
    // Lấy dữ liệu danh mục menu từ máy chủ
    fetchData() {
      this.isLoading = true;
      return conditionGets(this.roots)
        .then(res => {
          this.items = res.data || [];
        })
        .catch(err => {
          console.error("Lỗi khi tải danh mục menu:", err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    // Đếm số lượng menu theo phân loại
    countType(type) {
      return (this.items || []).filter(x => x.type === type).length;
    },

    // Màu sắc chip cho từng loại menu
    getTypeColor(type) {
      if (type === 'SECTION') return 'red darken-4';
      if (type === 'MENU') return 'green darken-2';
      if (type === 'SUBHEADER') return 'grey darken-1';
      if (type === 'GROUP') return 'blue darken-3';
      return 'teal darken-4';
    },

    // Đặt lại các tiêu chí lọc
    resetFilters() {
      this.filters = {
        id: '',
        title: '',
        type: null,
        routeName: ''
      };
    },

    // Đi vào xem nhóm menu con
    pushRoot(id) {
      if (!this.roots.includes(id)) {
        this.roots.push(id);
      }
      this.fetchData();
    },

    // Cắt bớt cấp thư mục khi nhấp vào breadcrumb
    sliceRoots(index) {
      this.roots = this.roots.slice(0, index + 1);
      this.fetchData();
    },

    // Đặt lại về thư mục menu gốc
    resetRoots() {
      this.roots = [];
      this.fetchData();
    },

    // Thay đổi thứ tự hiển thị menu
    changeItemOrder(id, type) {
      changeOrder(id, type, this.fetchData);
    },

    // Mở dialog tạo mới menu
    openCreateDialog() {
      this.isEdit = false;
      this.selectedItem = {
        parentId: this.roots.length > 0 ? this.roots[this.roots.length - 1] : null
      };
      this.formData = {};
      this.formDialog = true;
    },

    // Mở dialog chỉnh sửa menu
    openEditDialog(item) {
      this.isEdit = true;
      this.selectedItem = Object.assign({}, item);
      this.formData = Object.assign({}, item);
      this.formDialog = true;
    },

    // Nhận dữ liệu cập nhật từ component Detail
    handleDetailInput(data) {
      this.formData = data;
    },

    // Lưu dữ liệu tạo mới hoặc cập nhật menu
    saveForm() {
      this.isSubmitting = true;
      const promise = this.isEdit
        ? Put(this.selectedItem.id, this.formData)
        : Post(this.formData);

      promise
        .then(() => {
          this.formDialog = false;
          this.fetchData();
        })
        .catch(err => {
          console.error("Lỗi khi lưu menu:", err);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    // Mở dialog xác nhận xóa menu
    confirmDelete(item) {
      this.targetItem = item;
      this.dialogDelete = true;
    },

    // Thực hiện xóa menu sau khi xác nhận
    cfmDeleteItem() {
      if (!this.targetItem) return;
      conditionDelete(this.targetItem.id)
        .then(() => {
          this.dialogDelete = false;
          this.targetItem = null;
          this.fetchData();
        })
        .catch(err => {
          console.error("Lỗi khi xóa menu:", err);
        });
    }
  },
  mounted() {
    // Tải dữ liệu ban đầu
    this.fetchData();
  }
};
</script>

<style scoped>
/* Định dạng tiêu đề cột bảng dữ liệu */
.my-custom-table ::v-deep thead th {
  background-color: #F8F9FA !important; 
  height: 48px !important;
}

.my-custom-table ::v-deep thead th span {
  font-weight: 600 !important;
  color: #37474F !important;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
}

/* Hiệu ứng hover dòng trong bảng */
.my-custom-table ::v-deep tbody tr:hover {
  background-color: #F1F8E9 !important;
}
</style>